// eslint-disable-next-line
let _list;
let _source;
let _root;
let _rel;
let _key, _parentKey;
// eslint-disable-next-line
let _rootKey;

const reset = () => {
	_list = {};
	_source = {};
	_root = [];
	_rel = {};
	_key = null;
	_parentKey = null;
	_rootKey = 0;
};

export const filterObject = (obj = {}, callback) => {
	const ret = {};
	for( let k in obj ) {
		if ( !obj.hasOwnProperty(k)) continue;
		if ( callback(obj[k], k)) {
			ret[k] = {...obj[k]};
		}
	}
	return ret;
};

export const mapObject = (obj = {}, callback) => {
	const ret = {};
	for (let k in obj) {
		if ( !obj.hasOwnProperty(k)) continue;
		const called = callback(obj[k], k);
		ret[k] = typeof called === 'object' ? {...called} : called;
	}
	return ret;
};

export const objToArray = (obj = {} ) => {
	const ret = [];
	for (let k in obj ) {
		if ( !obj.hasOwnProperty(k)) continue;
		ret.push({...obj[k]});
	}
	return ret;
};


export const createServiceTree = ({source = {}, relations = {}, getKey, getParentKey, rootKey = 0}) => {
	reset();
	_source = source;
	_rootKey = rootKey;
	_key = getKey;
	_parentKey = getParentKey;
	_rel = relations;
	_root = rootKey;
	// _source.forEach(data => _list[_key(data)] = data);
	// _root = _source.filter(s => _parentKey(s) === rootKey);
	_root = filterObject(_source, s => _parentKey(s) === rootKey);
	_root = objToArray(_root);
	return build(_root);
};


const build = (list = []) => {
	return list.map((data) => {
		const id = _key(data);
		// const id = _key(data);
		if (_rel[id]) {
			data.children = _rel[id].map(child_id => {
				return _source[child_id];
			});
			data.children = build(data.children);
		}
		return data;
	});
};


export const createPartsTree = (source = {}, relations = {}, expansions = {}) => {
	source = {...source};
	relations = {...relations};
	const roots = objToArray(getRootParts(source, relations));
	return buildParts(roots, source, relations, expansions);
};

export const getPartExpansionIndex = (path = []) => ['path', ...path].join('-');

const buildParts = (list = [], source = {}, relations = {}, expansions = {}, parent = null, path = []) => {
	return list.map(data => {
		const id = data.part_id;
		data.path = [...path, data.part_id];
		data.key = parent ? `path-${parent.parent_id}-${id}` : `part-tree-${id}`;
		const expandIndex = getPartExpansionIndex(data.path);
		console.info('building... expansions', expandIndex, expansions);
		data.expanded = expansions[expandIndex] || false;
		if ( relations[id] ) {
			data.children = relations[id].map(relation => {
				const content = {...source[relation.child_id]};
				content.number_of_children = relation.number_of_children;
				content.parent_id = relation.parent_id;
				return content;
			});
			data.children = buildParts(data.children, source, relations, expansions, id, data.path);
		}
		return data;
	})
};

let visitedTests = {}
export const wouldBeCircular = (relations = {}, part, next) => {
	visitedTests = {};
	const {parent_id, part_id} = part;
	if ( parent_id ) {
		relations = relations[parent_id].filter(({child_id}) => child_id !== part_id);
	}
	if ( relations[next.part_id] ) {
		relations[next.part_id].push({
			parent_id: next.part_id,
			child_id: part_id,
			number_of_children: 1
		});
	} else {
		relations[next.part_id] = [{
			parent_id: next.part_id,
			child_id: part_id,
			number_of_children: 1
		}];
	}
	visitedTests[part_id] = true;
};


export const isCircular = (part, {path}) => {
	if ( !path ) return false;
	part = part.part_id || part;
	
};

const getRootParts = (source = {}, relations = {}) => filterObject(source, ({root}) => root);


// WEBPACK FOOTER //
// ./src/misc/tree-handler.js